import { 
    getFirestore, doc, getDocs, getDoc, setDoc, updateDoc, deleteDoc, collection, query, where 
  } from "firebase/firestore";
  
  const db = getFirestore();
  
  export const convertGuestToUser = async (userId) => {
    const wasGuest = localStorage.getItem("was_guest");
    const guest = JSON.parse(localStorage.getItem("guest_user"));
    
    // Not a guest → DO NOT MERGE
    if (wasGuest !== "true" || !guest) {
      console.log("Skipping merge → Not a guest session.");
      return;
    }

    const guestId = guest._id;
  
    // ----------- 1. Merge Cart ------------
    const cartQ = query(collection(db, "cart"), where("user", "==", guestId));
    const cartSnap = await getDocs(cartQ);
  
    for (let docSnap of cartSnap.docs) {
      const data = docSnap.data();
  
      await setDoc(doc(db, "cart", docSnap.id), {
        ...data,
        user: userId,
      });
  
      await deleteDoc(doc(db, "cart", docSnap.id));
    }
  
    // ----------- 2. Merge Wishlist ----------
    const wishQ = query(collection(db, "wishlist"), where("user", "==", guestId));
    const wishSnap = await getDocs(wishQ);
  
    for (let docSnap of wishSnap.docs) {
      const data = docSnap.data();
  
      await setDoc(doc(db, "wishlist", docSnap.id), {
        ...data,
        user: userId,
      });
  
      await deleteDoc(doc(db, "wishlist", docSnap.id));
    }
  
    // ----------- 3. Merge Addresses ----------
    const addrQ = query(collection(db, "addresses"), where("user", "==", guestId));
    const addrSnap = await getDocs(addrQ);
  
    for (let docSnap of addrSnap.docs) {
      const data = docSnap.data();
  
      await setDoc(doc(db, "addresses", docSnap.id), {
        ...data,
        user: userId,
      });
  
      await deleteDoc(doc(db, "addresses", docSnap.id));
    }
  
    // ---------- 4. Merge Temporary Orders (if any) ----
    const orderQ = query(collection(db, "orders"), where("user", "==", guestId));
    const orderSnap = await getDocs(orderQ);
  
    for (let docSnap of orderSnap.docs) {
      const data = docSnap.data();
  
      await setDoc(doc(db, "orders", docSnap.id), {
        ...data,
        user: userId,
      });
  
      await deleteDoc(doc(db, "orders", docSnap.id));
    }
  
    // ---------- 5. Remove guest from localStorage ----
    // CLEAR GUEST DATA
    localStorage.removeItem("guest_user");
    localStorage.removeItem("was_guest");
  
    console.log("Guest merged → User:", userId);
  };
  